import React from 'react'
import PropTypes from 'prop-types'

import Modal from '../../Modal/Modal'

import { useLoadTimer } from '../../ReactGAUtils/ReactGAUtils'
import { ModifiersFooter } from '../ModifiersFooter/ModifiersFooter'
import ModifiersLoader from '../Modifiers.loader'

export const LoadingModal = ({ onClose }) => {
  useLoadTimer({ category: 'Item Details' })
  return (
    <Modal
      loading
      footer={<ModifiersFooter loading isValid={false} />}
      onClose={onClose}
    >
      <ModifiersLoader />
    </Modal>
  )
}

LoadingModal.propTypes = {
  onClose: PropTypes.func.isRequired
}
